import { Tab, Tabs, Typography } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import AutoScrollContainer from '../../utils/AutoScrollContainer'
import { BMFinished } from './BottomMenu'
import { getAllChecked, isLungsFinished } from './finishUtils'
import FTab1Lungs from './FTab1Lungs'
import FTab2System from './FTab2System'
import { RHFinished } from './RunHeader'
import { useAppSelector } from './RunReduxHooks'
import { selectFinishChecks } from './sliceFinish'
import { selectProcHeader } from './sliceRunProcHeader'
import { TabIcon, TabPanel } from './utilsTabView'

export default function UIFinish() {
  const [tabValue, setTabValue] = useState(0)

  const finishChecks = useAppSelector(selectFinishChecks)
  const procHeader = useAppSelector(selectProcHeader)

  const [declined, setDeclined] = useState(false)
  const [accepted, setAccepted] = useState(false)
  const [count, setCount] = useState(0)

  const checkedLungsCount = useMemo(() => {
    return finishChecks.lungsChecks.filter((checked) => checked).length
  }, [finishChecks.lungsChecks])

  const requiredLungsCount = finishChecks.lungsChecks.length

  useEffect(() => {
    setCount(checkedLungsCount)
  }, [checkedLungsCount])

  useEffect(() => {
    if (procHeader?.isLungsAccepted === true) {
      setAccepted(true)
    }
  }, [procHeader?.isLungsAccepted])

  const effectiveAccepted = accepted || procHeader?.isLungsAccepted === true
  const allLungs = isLungsFinished(effectiveAccepted, finishChecks.lungsChecks)
  const allSystem = getAllChecked(finishChecks.systemChecks)

  const acceptedOutcomeComplete =
    allLungs &&
    checkedLungsCount === requiredLungsCount

  const outcomeComplete = acceptedOutcomeComplete || declined
  const isNextAvailable = outcomeComplete && allSystem

  const handleTabValueChange = (
    event: React.SyntheticEvent,
    newValue: number
  ) => {
    setTabValue(newValue)
  }

  return (
    <>
      <RHFinished />

      <Tabs
        value={tabValue}
        onChange={handleTabValueChange}
        style={{ height: '60px' }}
      >
        <Tab
          label={
            <Typography sx={{ fontSize: 14, fontWeight: 'bold' }}>
              Outcome
            </Typography>
          }
          icon={TabIcon(outcomeComplete)}
          iconPosition='end'
        />

        <Tab
          label={
            <Typography sx={{ fontSize: 14, fontWeight: 'bold' }}>
              System
            </Typography>
          }
          icon={TabIcon(allSystem)}
          iconPosition='end'
          disabled={!outcomeComplete}
        />
      </Tabs>

      <TabPanel value={tabValue} index={0}>
        <FTab1Lungs
          completion={() => {
          }}
          declined={declined}
          setDeclined={setDeclined}
          accepted={accepted}
          setAccepted={setAccepted}
          count={count}
          setCount={setCount}
        />
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <AutoScrollContainer bottomOffset={70}>
          <FTab2System
            completion={() => {
            }}
          />
        </AutoScrollContainer>
      </TabPanel>

      <BMFinished isNextAvailable={isNextAvailable} />
    </>
  )
}